import { render, staticRenderFns } from "./GalleryCarousel.vue?vue&type=template&id=36b43212&"
import script from "./GalleryCarousel.vue?vue&type=script&lang=js&"
export * from "./GalleryCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports